import { render, staticRenderFns } from "./MyPagePopup.vue?vue&type=template&id=1d2a152c"
import script from "./MyPagePopup.vue?vue&type=script&lang=js"
export * from "./MyPagePopup.vue?vue&type=script&lang=js"
import style0 from "./MyPagePopup.vue?vue&type=style&index=0&id=1d2a152c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports